'use client'
import { AdFree } from "@/ui/icons/AdFree"
import { Luxury } from "@/ui/icons/Luxury"
import { Synergy } from "@/ui/icons/Synergy"
import {
  getMembershipBadgeKind,
  MEMBERSHIP_ICON_SRC,
  type MembershipBadgeInput,
  type MembershipBadgeKind,
} from "@/util/membership"
import NextImage from "next/image"

const IconMap = {
  luxury: Luxury,
  synergy: Synergy,
  adFree: AdFree,
} as const

type MembershipBadgeProps = MembershipBadgeInput & {
  width?: number
  height?: number
  className?: string
  /** 使用 NextImage（适合需要 className 定位的场景） */
  asImage?: boolean
}

/** 当前用户会员标识图标：VIP 优先，非 VIP 且 ad_free 时展示 AD-Free */
export const MembershipBadge = ({
  vip,
  vipType,
  adFree,
  width = 20,
  height = 20,
  className,
  asImage = false,
}: MembershipBadgeProps) => {
  const kind = getMembershipBadgeKind({ vip, vipType, adFree })
  if (!kind) return null

  if (asImage) {
    return (
      <NextImage
        className={className}
        width={width}
        height={height}
        src={MEMBERSHIP_ICON_SRC[kind]}
        alt={kind}
      />
    )
  }

  const Icon = IconMap[kind]
  return <Icon className={className} width={width} height={height} />
}

export const membershipLabelKey = (kind: MembershipBadgeKind) => {
  switch (kind) {
    case "luxury":
      return "luxury" as const
    case "synergy":
      return "common.synergy" as const
    case "adFree":
      return "pricing.adFree" as const
    default:
      return null
  }
}

export { getMembershipBadgeKind, MEMBERSHIP_ICON_SRC }
export type { MembershipBadgeKind, MembershipBadgeInput }
